import React from "react";
import styles from './historymobile.module.css';
import { Tooltip } from "@mui/material";
import { Check, Clock, Eye } from "react-feather";
import { Link as Linkto } from "react-router-dom";
import dayjs from "dayjs";

const HistoryMobile = ({ isPanelOpen, onToggle, histories }) => {

    return (<>
        <div className={`${styles.AccordionList}`}>
            <div className={`${styles.AccordionListHead} ${isPanelOpen ? styles.Open : ""}`} onClick={() => onToggle("five")}>
                <p className={`${styles.Title}`}>History</p>
                <img src="/static/img/downTriangle.svg" />
            </div>
            <div className={`${styles.AccordionListBody} ${isPanelOpen ? styles.Open : ""}`}>
                <div className={`${styles.cardUnderSBody}`}>
                    <ul>
                        {histories?.map(item => {
                            if (item?.type === 'create') {
                                return <li className={`${styles.Completed}`}>
                                    <Tooltip title="Completed">
                                        <span><Check /></span>
                                    </Tooltip>
                                    <div>
                                        <p>{item?.title}</p>
                                        <p className={`${styles.Date}`}>{dayjs(item?.created_at).format('MMMM D, YYYY')}</p>
                                        <p className={`${styles.Description}`}>{item?.description}</p>
                                    </div>
                                </li>
                            }
                            /*if (item?.type === 'change_status') {
                                return <li className={`${styles.Completed}`}>
                                    <Tooltip title="Completed">
                                        <span><Check /></span>
                                    </Tooltip>
                                    <div>
                                        <p>{item?.title}</p>
                                        <p className={`${styles.Date}`}>{dayjs(item?.created_at).format('MMMM D, YYYY')}</p>
                                        <p className={`${styles.Description}`}>{item?.description}</p>
                                    </div>
                                </li>
                            }*/
                            return null;
                        })}
                        {/*} <li className={`${styles.Completed}`}>
                            <Tooltip title="Completed">
                                <span><Check /></span>
                            </Tooltip>
                            <div>
                                <p>Request was created</p>
                                <p className={`${styles.Date}`}>April 18, 2023</p>
                                <p className={`${styles.Description}`}>Nereida Greene from Apartment Unit 103, Weston Hall Dev created this request.</p>
                            </div>
                        </li>
                        <li className={`${styles.Completed}`}>
                            <Tooltip title="Completed">
                                <span><Check /></span>
                            </Tooltip>
                            <div>
                                <p>Status was changed</p>
                                <p className={`${styles.Date}`}>April 18, 2023</p>
                                <p className={`${styles.Description}`}>Mahendra P, Admin, Weston Hall Dev changed request status from  <span className={`${styles.Stat} ${styles.Open}`}>Open</span> to  <span className={`${styles.Stat} ${styles.InProgress}`}>In-Progress</span></p>
                            </div>
                        </li>
                        <li className={`${styles.Completed}`}>
                            <Tooltip title="Completed">
                                <span><Check /></span>
                            </Tooltip>
                            <div>
                                <p>Status was changed</p>
                                <p className={`${styles.Date}`}>April 18, 2023</p>
                                <p className={`${styles.Description}`}>Mahendra Patidar, Technician, Weston Hall Dev changed request status from  <span className={`${styles.Stat} ${styles.InProgress}`}>In-Progress</span> to <span className={`${styles.Stat} ${styles.Resolved}`}>Resolved</span></p>
                            </div>
                        </li>*/}
                    </ul>
                </div>
            </div>
        </div>
    </>)
}

export default HistoryMobile;
